import { areSortedArraysEquivalent } from '../../../utils/equivalence-utils';
import { temporaryNotificationDomainStore } from '../temporary-store/store';
export const hasNotification = (id, messages) => {
    return temporaryNotificationDomainStore.data.notifications.some(notification => notification.id === id && areSortedArraysEquivalent(notification.messages, messages));
};
//# sourceMappingURL=has-notification.js.map